
$(document).ready(function () {
    $('[data-load-route]').each((index, el) => {
        const route = $(el).attr('data-load-route');
        $(el).load(route);
    });
});